import React, {MouseEvent, useRef, useState} from 'react';
import classNames from "classnames";
import intl from "react-intl-universal";


import type {ItemModelType} from "@stores/WorkspaceStore";

import {useAppState} from "@stores/AppStateContext";

import {Tooltip} from "../../../../components/Tooltip"
import {MoreHorizontalIcon} from "../../../../components/icons/MoreHorizontalIcon";
import {openDocumentContextMenu} from "../../../context-menu/DocumentContextMenu/openDocumentContextMenu";


import './MoreActions.css';



export interface MoreActionsProps {
    item: ItemModelType;
}


export const MoreActions = ({item}: MoreActionsProps) => {
    const appState = useAppState();
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLElement | null>(null);
    return (
        <Tooltip title={intl.get('tooltip.moreActions.pageMenu').d('Page Menu')} isInBox={false}>
            <MoreHorizontalIcon
                className={classNames({
                    'MoreActions': true,
                    'MoreActions--open': isOpen,
                })}
                ref={ref}
                size={24}
                additionalPadding={8}
                fullHeight={true}
                onClick={(event: MouseEvent<HTMLElement>) => {
                    event.stopPropagation();
                    openDocumentContextMenu(appState, {
                        item,
                        event,
                        setIsOpen,
                        targetDom: ref.current!,
                    })
                }}
            />
        </Tooltip>
    )
}
